module.exports = __webpack_public_path__ + "static/media/English - Teaching - Road to Enlightenment (load_4) - translated by JL.1ff1ec08.txt";